import { loadStripe, Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | undefined;

/**
 * Lazily loaded Stripe.js instance (publishable key from the env). Lazy on purpose: the checkout
 * page only needs Stripe for the inline card form / 3DS, so pages that never reach that code must
 * not inject the Stripe script at module load (and unit tests can mock `@stripe/stripe-js`).
 */
export const getStripe = (): Promise<Stripe | null> => {
  stripePromise ??= loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!);
  return stripePromise;
};
